module.exports = __webpack_public_path__ + "img/regalo1.a6b65c3a.webp";